// src/components/PeoplePlan/EmployeeManagement/Dialogs/ConfirmationDialog.js
import React from "react";
import { createPortal } from "react-dom";
import styles from "./Dialogs.module.css";

const ConfirmationDialog = ({
  workflowName,
  selectedEmployees,
  onConfirm,
  onCancel,
  isSubmitting,
  isPositionRequest = false, // NEW: Add prop to detect position requests
}) => {
  const hasConflicts = !isPositionRequest && selectedEmployees.some(emp => emp.hasConflict);

  return createPortal(
    <div className={styles.confirmationDialog}>
      <div className={styles.dialogContent}>
        <h4>Confirm {isPositionRequest ? "Position Request" : "Workflow"}</h4>
        
        {isPositionRequest ? (
          <>
            <p>Do you really want to request {selectedEmployees.length} new position(s)?</p>
            <div className={styles.positionList}>
              {selectedEmployees.map((position, index) => (
                <div
                  key={`${position.store_corp}-${position.position_index}-${index}`}
                  className={styles.positionItem}
                >
                  <span className={styles.storeName}>
                    {position.store_corp}
                  </span>
                  <span className={styles.positionType}>
                    {position.position_type} 
                    {position.position_index && ` #${position.position_index}`}
                  </span>
                </div>
              ))}
            </div>
            <div className={styles.infoMessage}>
              These position requests will be sent to HR for approval and recruitment.
            </div>
          </>
        ) : (
          <>
            <p>Do you really want to start {workflowName} for:</p>
            <div className={styles.employeeList}>
              {selectedEmployees.map((employee) => (
                <div
                  key={employee.user_id}
                  className={`${styles.employeeItem} ${
                    employee.hasConflict ? styles.hasWorkflow : ""
                  }`}
                >
                  <span className={styles.employeeName}>
                    {employee.employee_name}
                  </span>
                  {employee.hasConflict && (
                    <span className={styles.workflowBadge}>
                      Already in Workflow
                    </span>
                  )}
                </div>
              ))}
            </div>
            {hasConflicts && (
              <div className={styles.conflictMessage}>
                Please deselect employees with active workflows to continue.
              </div>
            )}
          </>
        )}

        <div className={styles.dialogButtons}>
          <button
            onClick={onConfirm}
            disabled={isSubmitting || hasConflicts}
            className={hasConflicts ? styles.disabled : ""}
          >
            {isSubmitting ? "Processing..." : "Yes"}
          </button>
          <button onClick={onCancel} disabled={isSubmitting}>
            No
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationDialog;